module.exports = __webpack_public_path__ + "static/media/kyber.73b4b19e.svg";